import {AbstractStorageModule} from "@/services/storage/AbstractStorageModule";
import {app} from "@/app";
import {Context} from "@/services/storage/pixel/Context";
import uuid from 'uuid/v4';

type PixelMute = {
  active: boolean,
  createdAt: null|Date,
  timeout: number, // minutes
}

export class Pixel extends AbstractStorageModule {
    context = new Context();
    visitorId:null|string = null;

    muted: PixelMute = {
      active: false,
      createdAt: null,
      timeout: 60,
    };

    resolve() {
        if(app.isSandboxed) return;
        this.resolveVisitorId();
        this.resolveMutedState();
    }


    resolveVisitorId() {
        const localStorageKey = app.configOption('localStorage.visitorId.key');
        this.visitorId = window.localStorage.getItem(localStorageKey);
        if(!this.visitorId) {
            this.visitorId = uuid();
            window.localStorage.setItem(localStorageKey, this.visitorId ?? '');

            this.persistVisitorIdAsCartAttribute();
        }
    }

    persistVisitorIdAsCartAttribute() {
      if(!this.visitorId) return;

      const cartAttributeKey = '__ampx_visitor_id';

      app.storage.shopify.cart.updateCartAttributes({
        [cartAttributeKey]: this.visitorId,
      });
    }

    //(new Date()).getTime()
  resolveMutedState() {
    const localStorageKey = app.configOption('localStorage.mutedState.key');
    const muteCreatedAt = window.localStorage.getItem(localStorageKey);
    if(muteCreatedAt) {
      this.muted.createdAt = new Date(parseInt(muteCreatedAt));
      const diffMs = (new Date()).getTime() - this.muted.createdAt.getTime();
      const diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000);
      this.muted.active = (diffMins > this.muted.timeout);
    }
  }
  mute() {
    this.muted.active = true;
    this.muted.createdAt = new Date();

    const localStorageKey = app.configOption('localStorage.mutedState.key');
    window.localStorage.setItem(localStorageKey, this.muted.createdAt.getTime().toString());
  }

  unmute() {
    this.muted.active = false;
    this.muted.createdAt = null;

    const localStorageKey = app.configOption('localStorage.mutedState.key');
    window.localStorage.removeItem(localStorageKey);
  }
}
